import type { FaireProductEntity } from "../../entity_types/product";

export const p_4828w834w9: FaireProductEntity = {
  token: "p_4828w834w9",
  type: "product",
  name: "Flying Cork Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3e75d1260b1b663e3f8b360f47d265c043b219214af9953f6387a1c88801b31f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99666806d89caac072af859fb5a9c56caaed77b9b0b3073f661abe117307b082.png",
    "https://cdn.faire.com/fastly/5de82813ac8888ad423d8142e2fb7457ce24ce4815c5aa06d2176217effc7fb6.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:32.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
